module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "header-inner"
  }, [_c('div', {
    staticClass: "header-logo"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "7em"
    },
    attrs: {
      "src": "static/assets/img/logo.png",
      "alt": "Logo"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "header-content"
  }, [_c('div', {
    staticClass: "header-top"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "header-nav-secondary nav nav-pills"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Login")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Register")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "header-bottom"
  }, [_c('ul', {
    staticClass: "header-nav-primary nav nav-pills collapse navbar-collapse"
  }, [_c('li', {}, [_c('router-link', {
    attrs: {
      "to": "/forums"
    }
  }, [_vm._v("Forums")])], 1), _vm._v(" "), _c('li', {}, [_c('router-link', {
    attrs: {
      "to": "/cnpros"
    }
  }, [_vm._v("CNpros")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "cnsurveys"
    }
  }, [_vm._v("CNsurveys")])], 1), _vm._v(" "), _c('li', {}, [_c('router-link', {
    attrs: {
      "to": "#"
    }
  }, [_vm._v("How It Works")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/pricing"
    }
  }, [_vm._v("Plans & Pricing")])], 1), _vm._v(" "), (_vm.user != null && _vm.user != undefined && _vm.user != '') ? [_c('li', [_c('router-link', {
    attrs: {
      "to": "dashboard"
    }
  }, [_vm._v("Hello, " + _vm._s(_vm.user) + " "), _c('i', {
    staticClass: "fa fa-chevron-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "dashboard"
    }
  }, [_vm._v("My Account")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "login"
    }
  }, [_vm._v("Logout")])], 1)])], 1)] : [_c('li', {
    staticClass: "hidden-lg hidden-md"
  }, [_c('router-link', {
    attrs: {
      "to": "login"
    }
  }, [_vm._v("Log In")])], 1), _vm._v(" "), _c('li', {
    staticClass: "hidden-lg hidden-md"
  }, [_c('router-link', {
    attrs: {
      "to": "register"
    }
  }, [_vm._v("Sign Up")])], 1)]], 2), _vm._v(" "), _vm._m(1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "header-nav-social social-links nav nav-pills"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-google-plus"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": ".header-nav-primary"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb46dc78"}!./src/components/Second-Header/template.html
// module id = 168
// module chunks = 0